// extracted by mini-css-extract-plugin
export default {"component":"textarea__component___kvp5m","label":"textarea__label___nWHc2"};